import React, { useEffect, useState, useCallback, useContext } from 'react';

import { ColorContext } from './ColorContext';
import { ICorSelect, ICorRegistro } from '../../../modules/types/Cor';
import { getAllCores } from '../../../services/cores/corService';
import { AuthContext } from '../Auth/AuthContext';

interface Props {
  children: React.ReactNode;
}

export const ColorProvider: React.FC<Props> = ({ children }) => {
  const authContext = useContext(AuthContext);
  const user = authContext?.user ?? null;

  const [coresSelect, setCoresSelect] = useState<ICorSelect[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const carregarCores = useCallback(async () => {
    try {
      setLoading(true);

      const registros: ICorRegistro[] = await getAllCores();

      const cores: ICorSelect[] = registros
        .filter((cor) => cor.stRegistroAtivo === 'S')
        .map((cor) => ({
          id: cor.id,
          nomeCor: cor.nomeCor,
          codigoHexadecimal: cor.codigoHexadecimal,
        }));

      setCoresSelect(cores);
      localStorage.setItem('cores_select', JSON.stringify(cores));
    } catch (error) {
      console.error('Erro ao carregar cores:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Login / Logout
   */
  useEffect(() => {
    if (user) {
      localStorage.removeItem('cores_select');
      carregarCores();
    } else {
      // Logout
      setCoresSelect([]);
      setLoading(false);
    }
  }, [user, carregarCores]);

  /**
   * Fallback: reload com usuário já autenticado
   */
  useEffect(() => {
    if (!user) return;

    const cache = localStorage.getItem('cores_select');
    if (cache) {
      const parsed = JSON.parse(cache);
      if (Array.isArray(parsed)) {
        setCoresSelect(parsed);
        setLoading(false);
      }
    }
  }, [user]);

  return (
    <ColorContext.Provider
      value={{
        coresSelect,
        loading,
      }}
    >
      {children}
    </ColorContext.Provider>
  );
};
